import axios from 'axios';
const url = 'Modules/getAllModules'


export const fetchModules = () => {
    return axios.get(url)
}